import { referenceDataEndpoint } from "../globalConstants";
export const getToken = () => document.querySelector('[name="csrf-token"]').content;
const buildHeaders = () => ({
  'Content-Type': 'application/json',
  'X-CSRF-Token': getToken()
});
export const clientFetch = url => fetch(url, {
  method: 'GET',
  headers: buildHeaders()
}).then(response => {
  if (!response.ok) {
    throw new Error(`HTTP error ${response.status}`);
  }
  return response.json();
});
export const fetchReferenceDataFile = ({
  endpoint = referenceDataEndpoint,
  refFileId
}) => {
  if (!refFileId) {
    return Promise.resolve([]);
  }
  return clientFetch(endpoint.replace(':refId', refFileId));
};